export default __webpack_public_path__ + "static/media/train_logo.f83feeb0.png";